export const dailyMisConstants = {
    GET_DAILY_MIS_REQUEST: 'GET_DAILY_MIS_REQUEST',
    GET_DAILY_MIS_SUCCESS: 'GET_DAILY_MIS_SUCCESS',
    GET_DAILY_MIS_FAIL: 'GET_DAILY_MIS_FAIL',
}